import { createSlice } from "@reduxjs/toolkit";
import { getPromotion, updateUsePromotion } from "../../API/PromotionAPI";
const initialState = {
  Promotion: [],
  PromotionUse: [],
};

export const PromotionSlice = createSlice({
  name: "PromotionState",
  initialState,
  reducers: {
    updateGetPromotion: (state, action) => {
      state.Promotion = action.payload;
    },
    updateGetPromotionUse: (state, action) => {
      state.PromotionUse = action.payload;
    },
  },
});

export const { updateGetPromotion } = PromotionSlice.actions;
export const getPromotionDetail = (value) => async (dispatch) => {
  await getPromotion(value).then(async (data) => {
    await dispatch(updateGetPromotion(data));
  });
};

export const { updateGetPromotionUse } = PromotionSlice.actions;
export const updateUsePromotionAction =
  ({ promotion_code, token }) =>
  async (dispatch) => {
    const data = await updateUsePromotion(promotion_code, token);

    dispatch(updateGetPromotionUse(data));
    return data; // สำคัญ
  };

export default PromotionSlice.reducer;
